import React from 'react';
import PopOverFilter from './PopOverFilter';

const Filters = ({handleLogout,filtersLoading}) => {
  return ( 
    <PopOverFilter handleLogout={handleLogout}loading={filtersLoading}/>
  );
};

export default Filters;
